import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatErr } from "@/lib/api";
import { saveBrowseContext } from "@/lib/browseContext";
import ListingCard from "@/components/ListingCard";

export default function Watchlist() {
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/watchlist");
        const items = data.listings || [];
        setListings(items);
        saveBrowseContext(items.map((l) => l.id), "watchlist");
      } catch (err) { toast.error(formatErr(err)); }
      finally { setLoading(false); }
    })();
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-3 md:px-8 py-4 md:py-8">
      <div className="font-mono text-xs text-[#FF5F1F] tracking-widest uppercase">→ Watchlist</div>
      <h1 className="mt-2 font-display font-black uppercase text-3xl md:text-4xl tracking-tighter">On The Hunt</h1>
      <p className="mt-2 text-zinc-500 text-sm">Cards you&apos;re watching. We&apos;ll add price alerts soon.</p>

      {loading ? (
        <div className="py-24 text-center font-mono text-xs uppercase tracking-widest text-zinc-500">Loading…</div>
      ) : listings.length === 0 ? (
        <div className="py-16 text-center flex flex-col items-center">
          <img src="/graphics/empty-watchlist.png" alt="Bulldog on the hunt" className="max-w-[320px] w-full opacity-80" />
          <div className="font-display font-black uppercase text-2xl text-zinc-400 mt-6">Nothing saved yet.</div>
          <p className="mt-2 text-sm text-zinc-500">Tap the heart on a listing to add it here.</p>
        </div>
      ) : (
        <div className="mt-6 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-3 md:gap-4">
          {listings.map((l) => <ListingCard key={l.id} listing={l} />)}
        </div>
      )}
    </div>
  );
}
